// extracted by mini-css-extract-plugin
export default {"roundPicture":"ProfileWidget_roundPicture__PII5i","userName":"ProfileWidget_userName__EB6jx"};